<template>
    <section class="col s12">
		<template v-for="(item, item_i) in itens"> 
			<div v-if="(item.modalidade == modalidade || !item.modalidade) && (correcao == false || item.descricao == 'Relatório da ação extraído do SIGA')" class="card-panel">
				<div class="row">
					<input type="hidden" :name="`item_id_[${item.id}]`" :value="item.id">

					<div class="input-field col s12" v-if="item.tipo_item === 'resposta'">
						<strong>
							{{ item.descricao }}
						</strong>

						<textarea style="width: 100%; min-height: 150px;"
								  :ref="`item_${item.id}`"
								  :name="`item_[${item.id}]`"
								  :id="`item_${item.id}`"
								  :maxlength="item.quantidade_caracteres"
								  :placeholder="`Informe o(a)s ${item.descricao}`"
								  :disabled="allDisabled"
								  v-model="item.resposta"
								  cols="30" rows="10"
								  class="browser-default"></textarea>

						<span class="right" style="font-size: small;">{{ !item.resposta ? 0 : item.resposta.length }} / {{ item.quantidade_caracteres }}</span>

					</div>

					<div class="col s12" v-if="item.tipo_item === 'arquivo'">
						<strong>
							{{ item.descricao }}
						</strong>

						<p>
							Extensões válidas: PDF
						</p>

						<br>

						<a class="btn-floating btn-small waves-effect waves-light red"
						   @click="acionaEventoDeFileUpload(item.id)"
						   :disabled="allDisabled"
						   title="Upload do arquivo"><i class="material-icons">file_upload</i>

							<input tipo="materialize"
								   class="btn"
								   pai="inscricao"
								   type="file" :id="`item_${item.id}`" :name="`item_[${item.id}]`"
								   :disabled="allDisabled"
								   :ref="`item_${item.id}`"
								   accept="application/pdf"
								   @change="uploadArquivo(item.id, item_i)">
						</a>

						&nbsp;

						<span v-if="!item.hasOwnProperty('anexo')" class="">Nenhum arquivo anexado...</span>

						<div v-else style="display: inline;">
							&nbsp;

							<a class="btn-flat blue-text"
							   target="_blank"
							   :download="item.anexo.nome_anexo"
							   :href="linkParaDownload(item.anexo_id, item.anexo.arquivo, item.anexo.tipo_arquivo_extenso)">
								<i class="material-icons left">file_download</i>
								{{ item.anexo.nome_anexo }}
							</a>

							<input type="hidden" :name="`item_nome_anexo_[${item.id}]`" :value="item.anexo.nome_anexo">

							<input type="hidden" :name="`item_tamanho_anexo_kb_[${item.id}]`" :value="item.anexo.tamanho_arquivo_kb">

							<input type="hidden" :name="`item_tamanho_anexo_mb_[${item.id}]`" :value="item.anexo.tamanho_arquivo_mb">
						</div>

						<!--div class="file-field input-field">


							<p v-if="!item.hasOwnProperty('anexo')" class="">Nenhum arquivo anexado...</p>

							<p v-else><a :href="linkParaDownload(item.anexo.id, item.anexo.arquivo, item.anexo.tipo_arquivo_extenso)">{{ item.anexo.nome_anexo }}</a></p>
							<div class="file-path-wrapper">
								<input class="file-path validate" type="text">
							</div>
						</div-->
					</div>
				</div>

				<Resultado_avaliacoes_itens_acao :key="item_i"
												 v-if="avaliacoes"
												 :avaliacoes="avaliacoes"
												 :item-descricao="item.descricao"></Resultado_avaliacoes_itens_acao>

			</div>
		</template>
    </section>
</template>

<script>
import file_uploads from "../../../utils/file_uploads";
import Resultado_avaliacoes_itens_acao from "./avaliacoes_resultado/resultado_avaliacoes_itens_acao";

export default {
    name: "inscricao_questionario_itens",
    components: {Resultado_avaliacoes_itens_acao},
    props: {
        pItens: {
            type: Array,
            default: () => { return [] }
        },
        allDisabled: {
            type: Boolean,
            default : false,
        },
        pAvaliacoes: {
            type: Array|null,
            default: null,
        },
		modalidade: {
			type: String,
			default: null
		},
		correcao: {
			type: String,
			default: null
		}
    },
    data() {
        return {
            itens: this.pItens,
            avaliacoes: this.pAvaliacoes,
        }
    },
    watch: {
        pItens: {
            deep: true,
            handler(newValue){
                this.itens = newValue
            }
        },
        itens: {
            deep: true,
            handler(newValue){
                this.$emit('update:pItens', newValue)
            }
        },
    },
    methods: {
        acionaEventoDeFileUpload(itemId){
            const inputFileUpload = this.$refs[`item_${itemId}`][0];

            inputFileUpload.click()
        },
        uploadArquivo(itemId, indice) {
            const inputFileUpload = this.$refs[`item_${itemId}`][0];

            const arquivos = inputFileUpload.files

            if(arquivos !== undefined && arquivos !== null){
                const arquivo = arquivos[0]

                const anexo = file_uploads.retornaAnexo(arquivo, `ITEM_${itemId}_${arquivo.name}`, 'ITEM_INSCRICAO_RESPOSTA', ['pdf'])

                if(anexo){
                    this.$set(this.itens[indice], 'anexo', anexo)

                    this.itens[indice].anexo_id = null

                    M.toast({html: 'Arquivo anexado!'})
                }
            }
        },

        linkParaDownload(anexoId = null, arquivo = null, tipo_arquivo_extenso = null){
            return file_uploads.linkParaDownloadDeAnexosDeItemDaInscricao(anexoId, arquivo, tipo_arquivo_extenso)
        },


    },
    updated(){
        M.updateTextFields()
    }
}
</script>

<style scoped>

</style>
